import { useTheme } from "@mui-wrapper";
import { barClasses } from "@mui/x-charts-pro/BarChart";
import { BarChartPro } from "@mui/x-charts-pro/BarChartPro";
import { CHART_AXIS_LABEL_STYLE, CHART_HEIGHT, CHART_MARGIN, CHART_X_AXIS_HEIGHT, CHART_Y_AXIS_WIDTH } from "@components/analytics/in-house/constants/analytics-constants";
import { shouldRenderXTickLabel } from "@components/analytics/in-house/utils/analytics-utils";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Renders the bar variant for in-house analytics data. */
export function AnalyticsBarChart({
  dataset,
  xTickStep,
  yAxisLabel,
  seriesUnitLabel
}) {
  const theme = useTheme();
  return <>
      {/* eslint-disable @typescript-eslint/naming-convention -- MUI X chart API uses third-party prop names */}
      <BarChartPro height={CHART_HEIGHT} margin={CHART_MARGIN} xAxis={[Object.assign({
      scaleType: "band",
      data: dataset.map(item => item.label),
      tickLabelInterval: (_value, index) => shouldRenderXTickLabel(index, dataset.length, xTickStep),
      height: CHART_X_AXIS_HEIGHT,
      disableLine: true,
      disableTicks: true,
      tickLabelStyle: {
        fontSize: 14,
        fill: theme.vars.palette.text.secondary
      }
    }, {
      categoryGapRatio: 0.5
    })]} yAxis={[{
      min: 0,
      width: CHART_Y_AXIS_WIDTH,
      label: yAxisLabel,
      tickMinStep: 1,
      valueFormatter: value => `${Math.round(value ?? 0)}`,
      disableLine: true,
      disableTicks: true,
      labelStyle: {
        fill: theme.vars.palette.text.secondary,
        ...CHART_AXIS_LABEL_STYLE
      },
      tickLabelStyle: {
        fontSize: 14,
        fill: theme.vars.palette.text.secondary,
        transform: "translate(10px, 2px)"
      }
    }]} grid={{
      horizontal: true,
      vertical: false
    }} sx={{
      "&": {
        border: "none",
        outline: "none",
        boxShadow: "none",
        backgroundColor: "transparent"
      },
      ".MuiChartsAxis-root .MuiChartsAxis-tickLabel": {
        transform: "translateY(2px)"
      },
      ".MuiChartsAxis-line": {
        stroke: "transparent"
      },
      ".MuiChartsAxis-tick": {
        stroke: "transparent"
      },
      ".MuiChartsGrid-line": {
        stroke: PALETTE_VARS.divider,
        strokeDasharray: "2 5"
      },
      [`.${barClasses.element}`]: {
        fill: PALETTE_VARS.primary.light,
        rx: 2,
        ry: 2
      }
    }} series={[{
      data: dataset.map(item_0 => item_0.value),
      color: "primary.light",
      label: undefined,
      stack: undefined,
      type: "bar",
      valueFormatter: value_0 => `${value_0 ?? 0} ${seriesUnitLabel}`,
      highlightScope: {
        highlight: "none",
        fade: "none"
      }
    }]} />
      {/* eslint-enable @typescript-eslint/naming-convention */}
    </>;
}